export class EditBarUpDownActions {
    constructor(
        public isFirstRow: boolean | null = false,
        public isLastRow: boolean | null = false
    ) { }
}
